import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { testimonials } from "@/mocks/homeData";

export default function Testimonials() {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="testimonials" className="w-full py-16 md:py-24 bg-[#F0F0F0]">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <motion.div
            className="inline-flex items-center gap-2 mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <i className="ri-vip-diamond-line text-brand" />
            <span className="text-sm font-medium text-brand tracking-wide uppercase">
              {t("testimonials.label")}
            </span>
          </motion.div>
          <motion.h2
            className="text-3xl md:text-5xl font-bold text-stone-900"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.6, delay: 0.1, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {t("testimonials.heading")}
          </motion.h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonials.map((item, index) => (
            <motion.div
              key={item.id}
              className="bg-[#FEF3E8] rounded-2xl p-6 md:p-8 flex flex-col hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.5, delay: 0.1 * index, ease: [0.25, 0.1, 0.25, 1] }}
            >
              <div className="flex items-center gap-3 mb-4">
                <motion.div
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand flex items-center justify-center text-white font-bold text-sm md:text-base"
                  initial={{ scale: 0 }}
                  animate={isInView ? { scale: 1 } : { scale: 0 }}
                  transition={{ duration: 0.4, delay: 0.1 * index + 0.2, type: "spring", stiffness: 200 }}
                >
                  {item.avatar}
                </motion.div>
                <div>
                  <p className="text-sm md:text-base font-semibold text-stone-900">
                    {item.name}
                  </p>
                  <p className="text-xs md:text-sm text-stone-600">
                    {item.role}
                  </p>
                </div>
              </div>
              <div className="mb-3">
                <i className="ri-double-quotes-l text-2xl text-brand/30" />
              </div>
              <p className="text-sm md:text-base text-stone-700 leading-relaxed flex-1">
                {item.text}
              </p>
              <p className="text-xs md:text-sm text-stone-500 mt-4">
                {item.company}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}